module.exports = __webpack_public_path__ + "media/images/bf-logo-mini-4e7ccfa433d913e0d8c1812a2b7925e5.svg";